import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.27144 15.375C9.81609 14.4334 10.8341 13.8 12 13.8C13.166 13.8 14.184 14.4334 14.7286 15.375M3 15.825L4.05 6.56166L6.15 4.79996M21 15.825L19.95 6.56166L17.85 4.79996M9.3 16.05C9.3 17.7897 7.8897 19.2 6.15 19.2C4.4103 19.2 3 17.7897 3 16.05C3 14.3103 4.4103 12.9 6.15 12.9C7.8897 12.9 9.3 14.3103 9.3 16.05ZM21 16.05C21 17.7897 19.5897 19.2 17.85 19.2C16.1103 19.2 14.7 17.7897 14.7 16.05C14.7 14.3103 16.1103 12.9 17.85 12.9C19.5897 12.9 21 14.3103 21 16.05Z",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }